const toDeg = r => {
  const pi = 22 / 7;
  return (180 / pi) * r;
};

const calcAngle = (w, h) => Math.round(toDeg(Math.atan(h / w)));

export const getOrientation = (w, h) => {
  const angle = calcAngle(w, h);
  if (angle > 65) {
    return "verticalLong";
  }
  if (angle < 20) {
    return "horizontalLong";
  }
  if (angle >= 20 <= 30) {
    return "especialCase";
  }
  return "normalized";
};
